function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { ThemeContext } from "./themeContext";

/**
 * Takes an actual theme provided by ApplicationProvider or ThemeProvider and
 * @returns it to a functional component.
 *
 * @overview-example UseThemeSimpleUsage
 */
export const useTheme = () => {
  return React.useContext(ThemeContext);
};
/**
 * Service for working with Eva themes
 */

export class ThemeService {}

_defineProperty(ThemeService, "create", theme => {
  return Object.keys(theme).reduce((acc, key) => {
    return _objectSpread(_objectSpread({}, acc), {}, {
      [key]: ThemeService.getValue(key, theme, key)
    });
  }, {});
});

_defineProperty(ThemeService, "getValue", (name, theme, fallback) => {
  if (ThemeService.isReference(name)) {
    const themeKey = ThemeService.createKeyFromReference(name);
    return ThemeService.findValue(themeKey, theme) || fallback;
  }

  return ThemeService.findValue(name, theme) || fallback;
});

_defineProperty(ThemeService, "findValue", (name, theme) => {
  const value = theme[name];

  if (ThemeService.isReference(value)) {
    const themeKey = ThemeService.createKeyFromReference(value);
    return ThemeService.findValue(themeKey, theme);
  }

  return value;
});

_defineProperty(ThemeService, "isReference", value => {
  return `${value}`.startsWith('$');
});

_defineProperty(ThemeService, "createKeyFromReference", value => {
  return `${value}`.substring(1);
});